<script lang="ts">
    import src from './svg/download_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let spin: boolean = false;
    export let disabled: boolean = false;
    export let hover: string = '';
</script>

<TemplateIcon {src} {scale} alt="Drop down" on:click {spin} {disabled} {hover} />
